import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedRoute = ({ route }) => {
    const location = useLocation();

    return <Navigate to={{ pathname: route.redirect }} replace state={{ from: location }} />;
};
